export default "__VITE_ASSET__BIcJ8wrl__"